import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';

type TransitionProps = {
  direction?: 'left' | 'right' | 'up' | 'down';
  children: React.ReactElement;
};

function TransitionLeft(props: TransitionProps) {
  return <Slide {...props} direction="left" />;
}

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="up" />;
}

function TransitionRight(props: TransitionProps) {
  return <Slide {...props} direction="right" />;
}

function TransitionDown(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}

type DirectionSnackbarProps = {
  open: boolean;
  onClose: () => void;
  TransitionComponent?: React.ComponentType<TransitionProps>;
  message: string;
  color?: string;
};

const useStyles = makeStyles({
  closeIcon: {
    color: '#fff',
    padding: '2px'
  },
  snackbarContent: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    //width: '300px', // Adjust width as needed
    //height: '50px', // Adjust height as needed
    padding: '8px', // Add padding for better appearance
  },
  message: {
    
    flex: 1, // Let the message span take the remaining space
    color: '#fff',
  },
});

const DirectionSnackbar: React.FC<DirectionSnackbarProps> = ({ open, onClose, TransitionComponent = TransitionUp, message, color }) => {
  const classes = useStyles();

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      onClose={onClose}
      TransitionComponent={TransitionComponent}
      sx={{width:"100%"}}
    >
      <div style={{ backgroundColor: color }}>
        <div className={classes.snackbarContent}>
          <span className={classes.message}>{message}</span>
          <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </div>
      </div>
    </Snackbar>
  );
};

export default DirectionSnackbar;
